var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98857 1.5C11.2901 1.5 13.142 3.31109 13.142 5.547V6.69701C14.4338 7.10022 15.375 8.2696 15.375 9.6663V13.369C15.375 15.0981 13.9415 16.5 12.1742 16.5H5.8266C4.05852 16.5 2.625 15.0981 2.625 13.369V9.6663C2.625 8.2696 3.56696 7.10022 4.85796 6.69701V5.547C4.86559 3.31109 6.7175 1.5 8.98857 1.5ZM8.99619 10.0382C8.63038 10.0382 8.33316 10.3289 8.33316 10.6866V12.3412C8.33316 12.7064 8.63038 12.9971 8.99619 12.9971C9.36962 12.9971 9.66684 12.7064 9.66684 12.3412V10.6866C9.66684 10.3289 9.36962 10.0382 8.99619 10.0382ZM9.00381 2.80428C7.45674 2.80428 6.19927 4.02658 6.19165 5.5321V6.53528H11.8084V5.547C11.8084 4.03404 10.5509 2.80428 9.00381 2.80428Z",
    fill: "#8895A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.a99cbbfdc34cfe9bf5b004e8b94233c7.svg";
export { ForwardRef as ReactComponent };